export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024; // 5 MB

const VIDEO_EXT_RE = /\.(mp4|mov|webm)(\?|#|$)/i;
const ALLOWED_EXT_RE = /\.(svg|png|jpe?g|webp|gif|mp4|mov|webm)$/i;

/** Indica si una URL apunta a un recurso externo (http/https). */
export function isFullUrl(src: string): boolean {
  return src.startsWith("http://") || src.startsWith("https://");
}

type RawMedia =
  | string
  | { url?: string; path?: string; src?: string }
  | null
  | undefined;

/** Convierte cualquier formato de medio (string u objeto) a una ruta/URL. */
export function mediaToPath(item: RawMedia): string {
  if (!item) return "";
  if (typeof item === "string") return item;
  return item.url ?? item.path ?? item.src ?? "";
}

/** Normaliza la lista de imágenes de un producto a un arreglo de strings. */
export function normalizeMediaList(list: unknown): string[] {
  if (!Array.isArray(list)) return [];
  return list
    .map((item) => mediaToPath(item as RawMedia))
    .filter((value) => value.trim().length > 0);
}

/** Detecta si una URL/almacenamiento corresponde a un video. */
export function isVideoUrl(url: string): boolean {
  return VIDEO_EXT_RE.test(url);
}

/** Detecta si un File es un video (por tipo MIME o extensión). */
export function isVideoFile(file: File): boolean {
  return file.type.startsWith("video/") || VIDEO_EXT_RE.test(file.name);
}

/** Valida si el archivo es una imagen o video con formato permitido. */
export function isAllowedMedia(file: File): boolean {
  return (
    file.type.startsWith("image/") ||
    file.type.startsWith("video/") ||
    ALLOWED_EXT_RE.test(file.name)
  );
}

export function formatFileSize(bytes: number): string {
  if (bytes >= 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  return `${Math.round(bytes / 1024)} KB`;
}

/** Deja solo los dígitos de un número de teléfono. */
export function toWhatsAppNumber(phone: string): string {
  return phone.replace(/\D/g, "");
}

/** Construye el enlace de WhatsApp con mensaje prellenado. */
export function buildWhatsAppLink(phone: string, message: string): string {
  return `https://wa.me/${toWhatsAppNumber(phone)}?text=${encodeURIComponent(
    message
  )}`;
}